// ABOUTME: RTK Query endpoints for brand settings — GET public by key, GET authenticated for customer, PUT multipart.
// ABOUTME: PUT uses queryFn to bypass rootSlice's hardcoded Content-Type: application/json header for multipart/form-data.

import { rootSlice } from "../createRootSlice";
import { config } from "../apiUrlConfig";
import { ENV_TYPES } from "../../components/global/Sidebar";

export const brandRootSlice = rootSlice.injectEndpoints({
    endpoints: (builder) => ({
        getBrand: builder.query({
            query: (key) => ({
                url: `/brand/${key}`,
                method: 'GET',
            }),
            providesTags: (_result, _error, key) => [{ type: 'Brand', id: key }],
        }),

        // Authenticated — returns the first brand entry for the customer (Bearer + customer_id via rootSlice headers)
        getCustomerBrand: builder.query({
            query: () => ({
                url: `/brand/`,
                method: 'GET',
            }),
            providesTags: () => [{ type: 'Brand', id: 'customer' }],
        }),

        // PUT uses queryFn to send multipart/form-data.
        // The rootSlice baseQuery sets Content-Type: application/json globally,
        // which breaks multipart boundaries, so we bypass it with a manual fetch.
        updateBrand: builder.mutation({
            queryFn: async (args, api) => {
                const { name, colorHex, colorOpacity, logoLight, logoDark, sideImageLight, sideImageDark } = args;

                const formData = new FormData();
                if (name !== undefined) formData.append('name', name);
                if (colorHex !== undefined) formData.append('colorHex', colorHex);
                if (colorOpacity !== undefined) formData.append('colorOpacity', String(colorOpacity));
                if (logoLight) formData.append('logoLight', logoLight);
                if (logoDark) formData.append('logoDark', logoDark);
                if (sideImageLight) formData.append('sideImageLight', sideImageLight);
                if (sideImageDark) formData.append('sideImageDark', sideImageDark);

                const state = api.getState();
                const token = state.auth.token;
                const type = state.settings.environment.selectedEnvironmentType;
                const selectedId = state.settings.environment.selectedId;
                const relationCustomerId = state.settings.environment.relationCustomerId;

                const headers = {};
                if (token) headers['Authorization'] = `Bearer ${token}`;

                if (type === ENV_TYPES[100]) {
                    headers['customer_id'] = String(selectedId);
                } else if (type === ENV_TYPES[200]) {
                    headers['customer_id'] = String(relationCustomerId);
                }

                try {
                    const response = await fetch(`${config.url.API_ROOT_URL}brand`, {
                        method: 'PUT',
                        headers,
                        body: formData,
                    });

                    if (!response.ok) {
                        return { error: { status: response.status, data: await response.json() } };
                    }

                    return { data: await response.json() };
                } catch (error) {
                    return { error: { status: 'FETCH_ERROR', error: error.message } };
                }
            },
            invalidatesTags: () => [{ type: 'Brand' }],
        }),
    }),
});

export const { useGetBrandQuery, useGetCustomerBrandQuery, useUpdateBrandMutation } = brandRootSlice;
